import { render, staticRenderFns } from "./EditTicketTierModal.vue?vue&type=template&id=658826aa&scoped=true"
import script from "./EditTicketTierModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTicketTierModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditTicketTierModal.vue?vue&type=style&index=0&id=658826aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658826aa",
  null
  
)

export default component.exports